export default {
  path: '/business-hierarchy',
  component: {
    render: h => h('router-view'),
  },
  children: [
    {
      path: '/business-hierarchy/group-relationship-management',
      component: () =>
        import('./group-relationship-management/group-relationship-management'),
    },
    {
      path: '/business-hierarchy/group-limit-management',
      component: () =>
        import('./group-limit-management/group-limit-management'),
    },
    {
      path: '/business-hierarchy/group-assignment-management',
      component: () =>
        import('./group-assignment-management/group-assignment-management'),
    },
    {
      path: '/business-hierarchy/group-record-management',
      component: () =>
        import('./group-record-management/group-record-management'),
    },
  ],
}
